import { render, staticRenderFns } from "./AccountCodes.vue?vue&type=template&id=5fa442a2&scoped=true"
import script from "./AccountCodes.vue?vue&type=script&lang=js"
export * from "./AccountCodes.vue?vue&type=script&lang=js"
import style0 from "./AccountCodes.vue?vue&type=style&index=0&id=5fa442a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa442a2",
  null
  
)

export default component.exports